<template>
  <v-dialog v-model="open" persistent max-width="400px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          color="indigo"
          class="lead-bottom-control-panel__btn ml-2 mt-1 mb-1 white--text"
          v-bind="attrs"
          v-on="on"
        >
        <v-icon color="white">mdi-keyboard</v-icon>
        <span class="lead-bottom-control-panel__item-text">Dialpad</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Dialpad</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col
            cols="12"
            v-for="number in numbers"
            :key="number"
            md="4"
            sm="4"
            lg="4"
            class="center-buttons"
          >
            <v-btn
              @click="sendDigit(number)"
              large
              color="blue"
              class="dial-pad-btn white--text"
              >{{ number }}</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="open = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Dialpad",
  data() {
    return {
      open: false,
      numbers: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "*", "0", "#"],
    };
  },
  props: {
    connection: Object,
  },
  methods: {
    // Handle numeric buttons
    sendDigit(digit) {
      this.connection.sendDigits(digit);
    },
  },
};
</script>

<style>
.center-buttons {
  display: flex;
  justify-content: center;
}
.dial-pad-btn {
  font-size: 20px !important;
}
</style>